// @ts-strict-ignore
import * as React from 'react';
import { ButtonReact } from 'common/components/button';
import { ButtonSize, ButtonTheme } from 'common/components/button/constants';
import { SplitButtonReact } from 'common/components/split-button';
import { DisplaySize } from 'common/components/tooltip/types';
import { Translatable } from 'common/i18n';
import { useTranslation } from 'common/i18n/hooks';

/** renders saving controls based on the user's permission */
export const EditControls = (props: {
  resetTooltip: Translatable;
  isSaving: boolean;
  isSaved: boolean;
  canSave: boolean;
  canEdit: boolean;
  canReset: boolean;
  saveDisabledMessage?: Translatable;
  entityType: Translatable;
  metricUnitsSelector?: React.ReactNode;
  onReset?: () => void;
  onSave: () => void;
  onSaveMetric?: () => void;
  onClone: () => void;
}) => {
  const {
    t,
    print
  } = useTranslation();
  const saveLabel = t("query-builder.edit-controls.save-entity", {
    entityType: print(props.entityType)
  });
  const saveNewLabel = t("query-builder.edit-controls.save-new-entity", {
    entityType: print(props.entityType)
  });
  return <div className='modified-buttons' data-sentry-component="EditControls" data-sentry-source-file="edit-controls.tsx">
      {props.metricUnitsSelector}
      {/* users with edit access can save directly to this formula */}
      <SplitButtonReact className='save-button' disabled={!props.canSave || props.isSaving} theme={ButtonTheme.Secondary} sections={props.canEdit && [{
      items: [{
        label: saveLabel,
        value: "save"
      }, {
        label: saveNewLabel,
        value: "clone"
      }]
    }]} {...props.saveDisabledMessage && {
      tooltip: {
        text: props.saveDisabledMessage,
        size: DisplaySize.Medium
      }
    }} handleClick={() => {
      if (props.canEdit) {
        props.onSave();
      } else {
        props.onClone();
      }
    }} handleSelectChange={ev => {
      const action = ev.detail.item.value;
      const saveAsNew = action === "clone";
      if (saveAsNew) {
        props.onClone();
      } else {
        props.onSave();
      }
    }} data-sentry-element="SplitButtonReact" data-sentry-source-file="edit-controls.tsx">
        {props.isSaving ? t("query-builder.edit-controls.saving") : props.isSaved && !props.canReset ? t("query-builder.edit-controls.saved") : props.canEdit ? saveLabel : saveNewLabel}
      </SplitButtonReact>
      {props.isSaved && <ButtonReact className='reset-button' disabled={!props.canReset} theme={ButtonTheme.Secondary} size={ButtonSize.Medium} onClick={props.onReset} children={t("query-builder.edit-controls.reset")} tooltip={{
      text: props.canReset ? print(props.resetTooltip) : t("query-builder.edit-controls.no-unsaved-changes")
    }} />}
    </div>;
};